
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalEast as ObiBuoySphericalEastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-east.js';
 
 
 

 
 export const ObiBuoySphericalEast = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-east',
   elementClass: ObiBuoySphericalEastElement,
   events: {
     
   }
  });
 
 